/**
 * Data visualization: Purple colors
 */
export var purple10 = '#fbc7fb';
export var purple20 = '#f3a3f3';
export var purple20opacity20solidDark = '#4e4459';
export var purple30 = '#e888e8';
export var purple40 = '#d873d8';
export var purple40opacity20solidDark = '#493a54';
export var purple50 = '#c260c2';
export var purple50opacity20solid = '#f3dff3';
export var purple60 = '#a64ea6';
export var purple70 = '#843d84';
export var purple70opacity20solid = '#e6d8e6';
export var purple80 = '#612c61';
